<script>
export default {
  name: 'ArrowLeft',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#98780A',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 13 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5938 3.20625C12.5938 3.08125 12.5438 2.9625 12.4563 2.875L10.1312 0.55C9.95 0.36875 9.65 0.36875 9.46875 0.55C9.2875 0.73125 9.2875 1.03125 9.46875 1.2125L11 2.74375H0.875C0.61875 2.74375 0.40625 2.95625 0.40625 3.2125C0.40625 3.46875 0.61875 3.675 0.875 3.675H10.9938L9.46875 5.2C9.2875 5.38125 9.2875 5.68125 9.46875 5.8625C9.5625 5.95625 9.68125 6 9.8 6C9.91875 6 10.0375 5.95625 10.1312 5.8625L12.45 3.54375C12.4938 3.5 12.5312 3.44375 12.5563 3.38125C12.5563 3.375 12.5563 3.36875 12.5625 3.3625C12.5813 3.3125 12.5938 3.2625 12.5938 3.20625Z"
      :fill="color"
    />
  </svg>
</template>
